<template>
  <div class="currency-box">
    <el-select v-bind="$props" v-model="currentValue" @change="changeVal" placeholder="请选择">
      <el-option v-for="item in moneyIcon" :key="item" :label="item" :value="item">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      moneyIcon: ['$', '€', '￡', '₣', '¥', '₩']
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    changeVal(val, lr) {
      this.$emit('change', val, lr)
    }
  }
}
</script>

<style lang="scss" scoped>
.currency-box {
}
</style>
